export { apiMindbox } from 'next-flight-server-reference-proxy-loader?id=7f25920e0c90ee46e4337f907457b9e6bd2fc0e60e&name=apiMindbox!'